import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import WeaveColorTable from '../../components/WeaveColorTable/WeaveColorTable';
import { getWeaveColorRequestAction } from '../../store/weavecolor/weaveColorActions';

const WeaveColor = ({ weaveColorList, getWeaveColorRequest }) => {
  const navigate = useNavigate();

  useEffect(() => {
    getWeaveColorRequest({});
  }, [getWeaveColorRequest]);

  const handleCreate = () => {
    navigate('/weavecolor/create');
  };

  return (
    <div className="weavecolor-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">Weave Color Mappings</div>
        <WeaveColorTable weaveColorList={weaveColorList} />
      </CContainer>

      <CButton color="primary" className="create-order-fab" onClick={handleCreate}>
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  weaveColorList: state.weaveColorReducer?.weaveColorList || [],
});

const mapDispatchToProps = {
  getWeaveColorRequest: getWeaveColorRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(WeaveColor);
